// @core/api/endpoints/payment/set_default_payment_method.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetDefaultPaymentMethodRequest,
  SetDefaultPaymentMethodResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Set default payment method
 * Performs set operation on default payment method.
 */
export async function SetDefaultPaymentMethod(
  billingAccountId: string,
  paymentMethodId: string,
  data: SetDefaultPaymentMethodRequest,
  options?: RequestOptions
): Promise<SetDefaultPaymentMethodResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/payment-methods/:paymentMethodId/default`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  requestPath = requestPath.replace(':paymentMethodId', encodeURIComponent(paymentMethodId));
  const requestOptions = options;
  return client.post<SetDefaultPaymentMethodResponse>(requestPath, data, requestOptions);
}
